import { render, staticRenderFns } from "./ThgClosingCard.vue?vue&type=template&id=1c64a448&scoped=true"
import script from "./ThgClosingCard.vue?vue&type=script&lang=ts"
export * from "./ThgClosingCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgClosingCard.vue?vue&type=style&index=0&id=1c64a448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64a448",
  null
  
)

export default component.exports